import { render, staticRenderFns } from "./WorkspaceEmptyState.vue?vue&type=template&id=c7c19326&scoped=true"
import script from "./WorkspaceEmptyState.vue?vue&type=script&lang=js"
export * from "./WorkspaceEmptyState.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceEmptyState.vue?vue&type=style&index=0&id=c7c19326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c19326",
  null
  
)

export default component.exports